// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {findMatchingKey} from '../../shared/services/claim-shared-helper';
import {getPartTypesCollection} from './get-part-types';
import {translate} from '../../../shared/services/translation-service';

export const getPartTypeSelectedValue = (lifeTime, merchandizeItem) => {

    if (lifeTime) {

        return findMatchingKey('lifeTime', getPartTypesCollection());

    } else if (merchandizeItem) {

        return findMatchingKey('merchandizeItem', getPartTypesCollection());

    }

    return new KeyValuePair({
        key: '',
        value: translate('SERVICE_PART')
    });

};



// WEBPACK FOOTER //
// ./src/claim/parts/services/part-types.js